/* ARGOS CUSTOM CART v12 — optimistic UI + dedupe intercept + fast transitions
 * Cambi vs v7:
 *  - Critical CSS iniettato inline via JS (no dipendenze ordine caricamento)
 *  - Force-styles inline con setProperty('important') sull'elemento root
 *  - Shell appended a <html> per evitare parent transform/contain che rompono position:fixed
 *  - Animation rimossa al mount (slide solo all'apertura via class)
 *  - Console log su ogni step di open()/close()
 *  - Cart icon listener anche su delegated path (click su SVG/span dentro)
 *  - Match link cart con href === '/cart' OR finisce con /cart OR contiene cart in aria-label/class
 */
(function () {
  'use strict';

  var EXPRESS_VARIANT_ID = 51853736378500;
  var EXPRESS_PRODUCT_ID = 10331156185220;
  var IT_FLAG = 'https://flagcdn.com/w20/it.png';
  var PAYMENT_ICONS = ['amex','applepay','googlepay','klarna','mastercard','paypal','shoppay','visa'];

  var UPSELL_PRODUCTS = [
    { vid: 51848069054596, pid: 10329665798276, title: 'Kit Ricambio x3 - Testine Silenziose', price: 1790, oldPrice: 2290, badge: 'Risparmi 22%', img: 'https://cdn.shopify.com/s/files/1/1006/6591/7572/files/Kaching-Bundles-Untitled_design_49_49c79869-431e-461d-820d-7a298fc9739a.png?height=200&v=1782221598' },
    { vid: 51849245458564, pid: 10329816203396, title: 'Kit Ricambio x6 - Testine Silenziose', price: 2990, oldPrice: 4590, badge: 'Risparmi 35%', img: 'https://cdn.shopify.com/s/files/1/1006/6591/7572/files/Untitleddesign_60.png?height=200&v=1782222935' }
  ];

  var __silent = false;
  var __lastCart = null;

  function esc(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];
    });
  }
  function money(c) {
    if (c === 0) return 'GRATIS';
    return '€' + (c / 100).toFixed(2).replace('.', ',');
  }

  /* ============ CRITICAL CSS INJECTION ============ */
  function injectCriticalCSS() {
    if (document.getElementById('ag-cart-critical-css')) return;
    var st = document.createElement('style');
    st.id = 'ag-cart-critical-css';
    st.textContent = [
      'kaching-cart-drawer,.kaching-cart__inner{display:none !important;}',
      '#ag-cart{position:fixed !important;top:0 !important;right:0 !important;bottom:0 !important;left:0 !important;width:100vw !important;height:100vh !important;background:rgba(0,0,0,.45) !important;z-index:2147483647 !important;display:none;justify-content:flex-end !important;align-items:stretch !important;font-family:Manrope,system-ui,sans-serif !important;letter-spacing:-.005em;pointer-events:auto !important;margin:0 !important;padding:0 !important;}',
      '#ag-cart.is-open{display:flex !important;}',
      '#ag-cart .ag-panel{width:100% !important;max-width:440px !important;height:100% !important;background:#ffffff !important;display:flex !important;flex-direction:column !important;box-shadow:-8px 0 32px rgba(0,0,0,.18) !important;transform:translateX(100%);transition:transform .2s cubic-bezier(.22,.61,.36,1);position:relative !important;will-change:transform;}',
      '#ag-cart.is-open .ag-panel{transform:translateX(0) !important;}',
      'body.ag-locked{overflow:hidden !important;}',
      '#ag-cart .ag-item--gift{align-items:center !important;padding:6px 18px 6px 38px !important;}',
      '#ag-cart .ag-item--gift .ag-item__main{justify-content:center !important;gap:2px !important;}',
      '#ag-cart .ag-item--gift .ag-item__img{width:38px !important;height:38px !important;}',
      '#ag-cart .ag-item--gift .ag-item__right{justify-content:center !important;gap:4px !important;}',
      '#ag-cart .ag-item--gift::before{height:18px !important;top:14px !important;}',
      '#ag-cart .ag-item--gift .ag-item__price-final{background:linear-gradient(135deg,#4F6FFF,#2332D5) !important;-webkit-background-clip:border-box !important;background-clip:border-box !important;color:#fff !important;font-size:11px !important;font-weight:800 !important;letter-spacing:.4px !important;padding:4px 12px !important;border-radius:999px !important;box-shadow:0 3px 8px rgba(35,50,213,.25);}',
      '#ag-cart .ag-item--gift .ag-item__remove{padding:2px !important;}',
      '#ag-cart .ag-item--gift .ag-item__remove svg{width:13px !important;height:13px !important;}',
      '#ag-cart .ag-express__icon img{width:100%;height:100%;object-fit:contain;border-radius:8px;}',
      /* nascondi permanentemente i dialog cart native del theme Horizon */
      'dialog.cart-drawer__dialog,dialog[class*="cart-drawer"]{display:none !important;}',
      'dialog.cart-drawer__dialog::backdrop,dialog[class*="cart-drawer"]::backdrop{display:none !important;background:transparent !important;}'
    ].join('\n');
    (document.head || document.documentElement).appendChild(st);
  }

  /* mediaImage lookup dal Kaching Bundles config */
  function mediaImg(productId) {
    var mm = window.__abMediaMap || {};
    var dbs = document.querySelector('script.kaching-bundles-deal-block-settings');
    if (!dbs) return null;
    try {
      var s = JSON.parse(dbs.textContent);
      var all = [].concat(
        (s.dealBars || []),
        ((s.checkboxUpsells && s.checkboxUpsells.upsells) || []),
        ((s.progressiveGifts && s.progressiveGifts.gifts) || [])
      );
      for (var i = 0; i < all.length; i++) {
        var c = all[i];
        if (!c.productGID || !c.mediaImageGID) continue;
        if (c.productGID.indexOf(String(productId)) > -1 && mm[c.mediaImageGID]) return mm[c.mediaImageGID];
      }
    } catch (e) {}
    return null;
  }

  function resolveImg(productId, fallbackUrl) {
    return mediaImg(productId) || fallbackUrl || '';
  }

  function isGift(item) {
    return item.price === 0 || item.final_line_price === 0;
  }
  function isExpress(item) {
    return item.variant_id === EXPRESS_VARIANT_ID || item.product_id === EXPRESS_PRODUCT_ID;
  }
  /* per gift "spedizione/shipping" usa icona truck inline invece del product image errato */
  function giftIcon(item) {
    if (!isGift(item)) return null;
    var t = (item.product_title || '').toLowerCase();
    if (/spedizion|shipping|delivery/.test(t)) {
      var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#2332D5" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="6" width="13" height="11" rx="1.5"/><path d="M14 9h4l3 3v5h-7z"/><circle cx="6" cy="19" r="2"/><circle cx="17" cy="19" r="2"/></svg>';
      return 'data:image/svg+xml;charset=utf-8,' + svg.replace(/"/g,"'").replace(/#/g,'%23').replace(/</g,'%3C').replace(/>/g,'%3E');
    }
    return null;
  }

  /* ============ DOM SHELL ============ */
  function buildShell() {
    var d = document.createElement('div');
    d.id = 'ag-cart';
    /* belt-and-braces: stili critici anche inline con priorità !important via setProperty */
    var s = d.style;
    s.setProperty('position', 'fixed', 'important');
    s.setProperty('top', '0', 'important');
    s.setProperty('right', '0', 'important');
    s.setProperty('bottom', '0', 'important');
    s.setProperty('left', '0', 'important');
    s.setProperty('z-index', '2147483647', 'important');
    s.setProperty('display', 'none', 'important');
    s.setProperty('background', 'rgba(0,0,0,.45)', 'important');
    s.setProperty('pointer-events', 'auto', 'important');

    d.innerHTML = ''
      + '<div class="ag-panel" role="dialog" aria-modal="true">'
      +   '<div class="ag-head">'
      +     '<h2 class="ag-title">Carrello (<span class="ag-count">0</span>)</h2>'
      +     '<button class="ag-close" type="button" aria-label="Chiudi">'
      +       '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 18 18 6M6 6l12 12"/></svg>'
      +     '</button>'
      +   '</div>'
      +   '<div class="ag-announce">Offerte Riservate ancora per <strong class="ag-timer">10:00</strong></div>'
      +   '<div class="ag-trust">'
      +     '<span class="ag-trust-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>Spedizione gratuita</span>'
      +     '<span class="ag-trust-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0z"/><path d="M12 14c-4 0-7 2.5-7 6v1h14v-1c0-3.5-3-6-7-6z"/></svg>100.000+ clienti</span>'
      +   '</div>'
      +   '<div class="ag-body">'
      +     '<div class="ag-items" aria-live="polite"></div>'
      +     '<div class="ag-upsell">'
      +       '<h3 class="ag-upsell-title">Non farti mancare...</h3>'
      +       '<div class="ag-upsell-list"></div>'
      +     '</div>'
      +   '</div>'
      +   '<div class="ag-foot">'
      +     '<div class="ag-express">'
      +       '<div class="ag-express__icon"><img src="https://cdn.shopify.com/s/files/1/1006/6591/7572/files/download.png?v=1778683260" alt=""></div>'
      +       '<div class="ag-express__main">'
      +         '<div class="ag-express__title">Spedizione Assicurata</div>'
      +         '<div class="ag-express__desc">Pacco perso, rubato o danneggiato? Te lo rispediamo GRATIS.</div>'
      +       '</div>'
      +       '<div class="ag-express__price">€2,95</div>'
      +       '<button class="ag-toggle" type="button" role="switch" aria-checked="false"><span class="ag-toggle__h"></span></button>'
      +     '</div>'
      +     '<div class="ag-ship-row">'
      +       '<img class="ag-flag" src="' + IT_FLAG + '" alt="IT">'
      +       '<span class="ag-ship-label">Spedizione in IT</span>'
      +       '<span class="ag-ship-free">GRATIS</span>'
      +     '</div>'
      +     '<button class="ag-checkout" type="button">CHECKOUT SICURO · <span class="ag-total">€0,00</span></button>'
      +     '<button class="ag-rapid" type="button">Checkout Rapido <svg viewBox="0 0 10 6" width="10" height="6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M9 1 5 5 1 1"/></svg></button>'
      +     '<div class="ag-pay">' + PAYMENT_ICONS.map(function(p){return '<img src="https://cart-assets.kachingappz.app/payment-method-icons/'+p+'.svg" alt="'+p+'">';}).join('') + '</div>'
      +   '</div>'
      + '</div>';
    return d;
  }

  function ensureShell() {
    var d = document.getElementById('ag-cart');
    if (d) return d;
    injectCriticalCSS();
    d = buildShell();
    /* append a <html>: bypass eventuali parent transform/contain sul body */
    document.documentElement.appendChild(d);
    wire(d);
    return d;
  }

  /* ============ RENDER ============ */
  function renderItems(cart) {
    var root = ensureShell();
    var itemsEl = root.querySelector('.ag-items');
    var tgl = root.querySelector('.ag-toggle');
    if (tgl) {
      tgl.setAttribute('aria-checked', String(((cart && cart.items) || []).some(isExpress)));
      /* direct handler (no delegate): rimpiazza ad ogni render per garantire bind */
      tgl.onclick = handleToggleClick;
    }

    if (!cart || !cart.items || cart.items.length === 0) {
      itemsEl.innerHTML = '<div class="ag-empty">Il carrello è vuoto.</div>';
      root.querySelector('.ag-count').textContent = '0';
      root.querySelector('.ag-total').textContent = '€0,00';
      return;
    }
    /* sort: paid items prima, gift dopo (mantieni ordine interno) */
    var paid = [], gifts = [];
    cart.items.forEach(function(it){ if (isExpress(it)) return; (isGift(it) ? gifts : paid).push(it); });
    var ordered = paid.concat(gifts);
    var html = '';
    ordered.forEach(function (item) {
      var gift = isGift(item);
      var saved = item.original_line_price - item.final_line_price;
      var img = resolveImg(item.product_id, item.image);
      html += '<div class="ag-item' + (gift ? ' ag-item--gift' : '') + '" data-key="' + esc(item.key) + '">';
      html += '<a href="' + esc(item.url) + '"><img class="ag-item__img" src="' + esc(img) + '" alt=""></a>';
      html += '<div class="ag-item__main">';
      html += '<a class="ag-item__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>';
      if (!gift) {
        html += '<div class="ag-item__qty">';
        html += '<button class="ag-item__qty-btn" data-act="dec" type="button">−</button>';
        html += '<span class="ag-item__qty-val">' + item.quantity + '</span>';
        html += '<button class="ag-item__qty-btn" data-act="inc" type="button">+</button>';
        html += '</div>';
      }
      html += '</div>';
      html += '<div class="ag-item__right">';
      if (item.original_line_price > item.final_line_price) {
        html += '<span class="ag-item__price-old">' + money(item.original_line_price) + '</span>';
      }
      html += '<span class="ag-item__price-final">' + (gift ? 'GRATIS' : money(item.final_line_price)) + '</span>';
      if (saved > 0 && !gift) html += '<div class="ag-item__saved">Risparmi ' + money(saved) + '</div>';
      html += '<button class="ag-item__remove" data-act="remove" type="button"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg></button>';
      html += '</div>';
      html += '</div>';
    });
    itemsEl.innerHTML = html;
    root.querySelector('.ag-count').textContent = cart.item_count;
    root.querySelector('.ag-total').textContent = money(cart.total_price);
  }

  function renderUpsells(cart) {
    var root = ensureShell();
    var list = root.querySelector('.ag-upsell-list');
    UPSELL_PRODUCTS.forEach(function (u) {
      var mi = mediaImg(u.pid);
      if (mi) { u.img = mi; return; }
      var s = document.querySelector('script.kaching-bundles-product[data-product-id="' + u.pid + '"]');
      if (s) {
        try { var d = JSON.parse(s.textContent); if (d.image) u.img = d.image.indexOf('//')===0 ? 'https:'+d.image : d.image; } catch (e) {}
      }
    });
    /* skip solo se l'utente l'ha aggiunto come item paid (non gift) */
    var paidPids = ((cart && cart.items) || []).filter(function(i){return !isGift(i);}).map(function(i){return String(i.product_id);});
    var html = '';
    UPSELL_PRODUCTS.forEach(function (u) {
      if (paidPids.indexOf(String(u.pid)) > -1) return;
      html += '<div class="ag-upsell-item">';
      html += '<img class="ag-upsell-item__img" src="' + esc(u.img) + '" alt="">';
      html += '<div class="ag-upsell-item__main">';
      html += '<div class="ag-upsell-item__title">' + esc(u.title) + '</div>';
      html += '<div class="ag-upsell-item__prices">';
      html += '<span class="ag-upsell-item__price">' + money(u.price) + '</span>';
      html += '<span class="ag-upsell-item__price-old">' + money(u.oldPrice) + '</span>';
      html += '<span class="ag-upsell-item__badge">' + esc(u.badge) + '</span>';
      html += '</div>';
      html += '</div>';
      html += '<button class="ag-upsell-item__add" data-vid="' + u.vid + '" type="button">Aggiungi</button>';
      html += '</div>';
    });
    list.innerHTML = html;
  }

  /* ============ API Cart ============ */
  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function(r){return r.json();});
  }
  function applyCart(cart) {
    if (!cart) return cart;
    /* offerta v2 (pagina test, niente Kaching): i regali €0 (_ag_gift) restano solo se c'è un prodotto dell'offerta (_ag_tier) */
    var agItems = cart.items || [];
    var agOrphans = agItems.filter(function (it) { return it.properties && it.properties._ag_gift; });
    if (agOrphans.length && !agItems.some(function (it) { return it.properties && it.properties._ag_tier; })) {
      var agUpd = {}; agOrphans.forEach(function (it) { agUpd[it.key] = 0; });
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: agUpd }) })
        .then(function (r) { return r.json(); }).then(applyCart);
    }
    __lastCart = cart;
    renderItems(cart);
    renderUpsells(cart);
    return cart;
  }
  /* changeQty optimistic: aggiorna __lastCart subito (rimuovi line se qty=0, altrimenti aggiorna qty), poi fetch */
  function changeQty(key, qty) {
    /* optimistic */
    if (__lastCart && __lastCart.items) {
      var idx = -1;
      for (var i = 0; i < __lastCart.items.length; i++) if (__lastCart.items[i].key === key) { idx = i; break; }
      if (idx >= 0) {
        if (qty === 0) {
          var removed = __lastCart.items[idx];
          __lastCart.items.splice(idx, 1);
          __lastCart.item_count = Math.max(0, (__lastCart.item_count || 0) - (removed.quantity || 1));
          __lastCart.total_price = Math.max(0, (__lastCart.total_price || 0) - (removed.final_line_price || 0));
        } else {
          var it = __lastCart.items[idx];
          var unitFinal = it.quantity ? it.final_line_price / it.quantity : it.final_price;
          var unitOrig = it.quantity ? it.original_line_price / it.quantity : it.original_price;
          var diffQty = qty - it.quantity;
          it.quantity = qty;
          it.final_line_price = Math.round(unitFinal * qty);
          it.original_line_price = Math.round(unitOrig * qty);
          __lastCart.item_count = (__lastCart.item_count || 0) + diffQty;
          __lastCart.total_price = (__lastCart.total_price || 0) + Math.round(unitFinal * diffQty);
        }
        renderItems(__lastCart);
        renderUpsells(__lastCart);
      }
    }
    __silent = true;
    return fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function(r){return r.json();}).then(function (cart) {
      __silent = false;
      return applyCart(cart);
    }).catch(function(){ __silent = false; });
  }
  function addVariant(id, qty) {
    __silent = true;
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function(r){return r.json();}).then(function(){ return fetchCart(); }).then(function (cart) {
      __silent = false;
      return applyCart(cart);
    }).catch(function(){ __silent = false; });
  }

  /* ============ OPEN / CLOSE ============ */
  function open() {
    try {
      injectCriticalCSS();
      var d = ensureShell();
      if (d.classList.contains('is-open')) return;
      if (__lastCart) { renderItems(__lastCart); renderUpsells(__lastCart); }
      d.classList.add('is-open');
      d.style.setProperty('display', 'flex', 'important');
      d.style.removeProperty('visibility');
      d.style.removeProperty('pointer-events');
      document.body.classList.add('ag-locked');
      fetchCart().then(applyCart);
    } catch (e) { console.error('[AG-CART] open() error:', e); }
  }
  function close() {
    var d = document.getElementById('ag-cart');
    if (d) {
      d.classList.remove('is-open');
      d.style.setProperty('display', 'none', 'important');
      d.style.setProperty('visibility', 'hidden', 'important');
      d.style.setProperty('pointer-events', 'none', 'important');
    }
    /* cleanup aggressivo: classi body/html, dialog native, attributi open, scroll lock */
    ['ag-locked','kaching-body__cart-open','cart-open','drawer-open','overflow-hidden','no-scroll','scroll-locked'].forEach(function(c){
      document.body.classList.remove(c);
      document.documentElement.classList.remove(c);
    });
    document.body.style.removeProperty('overflow');
    document.documentElement.style.removeProperty('overflow');
    document.querySelectorAll('dialog[open]').forEach(function(dlg){
      try { dlg.close(); } catch(e){}
      dlg.removeAttribute('open');
    });
    /* nascondi cart-drawer-component se mai diventato visibile */
    document.querySelectorAll('cart-drawer-component, dialog.cart-drawer__dialog, dialog[class*="cart-drawer"]').forEach(function(el){
      el.style.setProperty('display','none','important');
    });
  }

  /* ============ EVENTS ============ */
  function wire(root) {
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (t === root) { close(); return; }
      if (t.closest && t.closest('.ag-close')) { e.preventDefault(); close(); return; }
      if (t.closest && (t.closest('.ag-checkout') || t.closest('.ag-rapid'))) { window.location.href = '/checkout'; return; }
      var qb = t.closest && t.closest('[data-act="inc"], [data-act="dec"]');
      if (qb) {
        var it = qb.closest('.ag-item');
        var cur = parseInt(it.querySelector('.ag-item__qty-val').textContent, 10) || 1;
        var nq = qb.dataset.act === 'inc' ? cur + 1 : Math.max(0, cur - 1);
        changeQty(it.dataset.key, nq);
        return;
      }
      if (t.closest && t.closest('[data-act="remove"]')) {
        var ir = t.closest('.ag-item');
        changeQty(ir.dataset.key, 0);
        return;
      }
      var add = t.closest && t.closest('[data-vid]');
      if (add) {
        add.disabled = true;
        add.textContent = '...';
        addVariant(parseInt(add.dataset.vid, 10)).then(function () { add.textContent = '✓'; });
        return;
      }
    });
  }

  function handleToggleClick(e) {
    var tgl = e.currentTarget;
    if (e && e.preventDefault) e.preventDefault();
    if (e && e.stopPropagation) e.stopPropagation();
    var on = tgl.getAttribute('aria-checked') === 'true';
    /* UI optimistic immediato */
    tgl.setAttribute('aria-checked', String(!on));
    /* aggiorna __lastCart in memoria + total live */
    if (__lastCart) {
      if (!on) {
        if (!__lastCart.items.some(isExpress)) {
          __lastCart.items.push({ key: '__express_pending__', variant_id: EXPRESS_VARIANT_ID, product_id: EXPRESS_PRODUCT_ID, quantity: 1, price: 295, final_line_price: 295, original_line_price: 295, product_title: 'Spedizione Assicurata' });
          __lastCart.item_count++;
          __lastCart.total_price += 295;
        }
      } else {
        var i = -1;
        for (var k = 0; k < __lastCart.items.length; k++) if (isExpress(__lastCart.items[k])) { i = k; break; }
        if (i >= 0) {
          var ln = __lastCart.items[i];
          __lastCart.items.splice(i, 1);
          __lastCart.item_count = Math.max(0, __lastCart.item_count - (ln.quantity||1));
          __lastCart.total_price = Math.max(0, __lastCart.total_price - (ln.final_line_price||0));
        }
      }
      var totEl = document.querySelector('#ag-cart .ag-total'); if (totEl) totEl.textContent = money(__lastCart.total_price);
      var cntEl = document.querySelector('#ag-cart .ag-count'); if (cntEl) cntEl.textContent = __lastCart.item_count;
    }
    /* API in background, no disabled state per fluidità */
    if (!on) {
      addVariant(EXPRESS_VARIANT_ID, 1);
    } else {
      fetchCart().then(function(c){
        var l = (c.items||[]).find(isExpress);
        if (l) return changeQty(l.key, 0);
        applyCart(c);
      });
    }
  }

  /* ============ CART ICON LISTENER ============ */
  function looksLikeCartTrigger(node) {
    if (!node || node.nodeType !== 1) return false;
    /* check the node and its anchor ancestor */
    var el = node.closest && node.closest('a, button, [role="button"]');
    if (!el) el = node;
    var href = (el.getAttribute && el.getAttribute('href')) || '';
    if (href === '/cart' || /^\/cart[?#]/.test(href) || /\/cart$/.test(href.split('?')[0])) return true;
    var aria = (el.getAttribute && el.getAttribute('aria-label')) || '';
    if (/cart|carrello/i.test(aria)) return true;
    var cls = (el.className && typeof el.className === 'string' ? el.className : '') || '';
    if (/(^|[\s_-])cart(-|_|\s|$)/i.test(cls) || /pdp-header__cart|cart-icon|icon-cart|cart-link|header__cart/i.test(cls)) return true;
    var id = el.id || '';
    if (/cart-icon-bubble|cart-bubble|cart-toggle/i.test(id)) return true;
    return false;
  }

  function onCartIconClick(e) {
    var t = e.target;
    if (!t || t.nodeType !== 1) return;
    /* ignora click che originano dentro al nostro drawer */
    if (t.closest && t.closest('#ag-cart')) return;
    /* il trigger DEVE essere un elemento interattivo concreto (no ancestor passivi) */
    var el = t.closest && t.closest('a, button, [role="button"], [data-cart-icon], cart-icon, cart-icon-bubble');
    if (!el) return;
    if (!looksLikeCartTrigger(el)) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    open();
  }

  /* ============ HEADER CART BUTTON HIJACK ============ */
  function hijackHeaderCartButtons() {
    var sels = [
      'button[data-testid="cart-drawer-trigger"]',
      'button[aria-label="Carrello"]',
      'a[href="/cart"]',
      'cart-icon',
      'cart-icon-bubble'
    ];
    sels.forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(btn){
        if (btn.dataset.agHijacked) return;
        btn.dataset.agHijacked = '1';
        /* rimuovi attributi command/on:click che attivano dialog nativo */
        btn.removeAttribute('on:click');
        btn.removeAttribute('command');
        btn.removeAttribute('commandfor');
        btn.removeAttribute('popovertarget');
        /* listener diretto in capture phase */
        btn.addEventListener('click', function(e){
          e.preventDefault();
          e.stopPropagation();
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();
          open();
        }, true);
      });
    });
  }

  /* ============ INIT ============ */
  function init() {
    injectCriticalCSS();
    ensureShell();
    hijackHeaderCartButtons();
    /* re-hijack quando il theme rerende l'header (es. update count) */
    var mo = new MutationObserver(function(){ hijackHeaderCartButtons(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });

    /* dedupe: un solo refresh+open per finestra temporale */
    var __addBouncer = null;
    function onCartAdd() {
      if (__addBouncer) return;
      __addBouncer = setTimeout(function(){
        __addBouncer = null;
        fetchCart().then(function(c){ applyCart(c); open(); });
      }, 0);
    }

    var nf = window.fetch;
    window.fetch = function (resource, init) {
      var url = typeof resource === 'string' ? resource : (resource && resource.url);
      var p = nf.apply(this, arguments);
      if (url && /\/cart\/add(\.js)?(\?|$)/.test(url) && !__silent) {
        p.then(onCartAdd).catch(function(){});
      }
      return p;
    };

    var xo = window.XMLHttpRequest.prototype.open;
    var xs = window.XMLHttpRequest.prototype.send;
    window.XMLHttpRequest.prototype.open = function (m, u) { this.__url = u; return xo.apply(this, arguments); };
    window.XMLHttpRequest.prototype.send = function () {
      var s = this;
      this.addEventListener('load', function () {
        if (s.__url && /\/cart\/add(\.js)?(\?|$)/.test(s.__url) && !__silent) onCartAdd();
      });
      return xs.apply(this, arguments);
    };

    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.matches) return;
      if (f.matches('form[action="/cart/add"], form[action^="/cart/add"]')) {
        e.preventDefault();
        var fd = new FormData(f);
        fetch('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
          .then(function(){ return fetchCart(); })
          .then(function (c) { applyCart(c); open(); })
          .catch(function () { f.submit(); });
      }
    }, true);

    /* capture + bubble, sia su document che window per max copertura */
    document.addEventListener('click', onCartIconClick, true);
    document.addEventListener('click', onCartIconClick, false);
    window.addEventListener('click', onCartIconClick, true);

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    var m = 9, s = 59;
    setInterval(function () {
      s--; if (s < 0) { s = 59; m--; } if (m < 0) { m = 9; s = 59; }
      var t = document.querySelector('.ag-timer');
      if (t) t.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    }, 1000);

    fetchCart().then(function (c) { __lastCart = c; renderItems(c); renderUpsells(c); });
  }

  function safeInit() {
    try { init(); console.log('[AG-CART v10] inited OK'); }
    catch (e) { console.error('[AG-CART v10] init error:', e); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeInit);
  } else {
    safeInit();
  }
  window.addEventListener('load', function () {
    if (!document.getElementById('ag-cart')) safeInit();
  });

  window.__agCart = {
    open: open,
    close: close,
    refresh: function(){ return fetchCart().then(function(c){__lastCart=c; renderItems(c); renderUpsells(c);}); },
    debug: function(){
      var d = document.getElementById('ag-cart');
      console.log('shell exists:', !!d);
      if (!d) return;
      console.log('classes:', d.className);
      console.log('inline style display:', d.style.display);
      console.log('computed:', getComputedStyle(d).display, getComputedStyle(d).position, getComputedStyle(d).zIndex);
      console.log('rect:', d.getBoundingClientRect());
      console.log('parent:', d.parentElement);
    }
  };
})();
